"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunnelIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 25" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M22 0.5C22.8284 0.5 23.5 1.17157 23.5 2V3.13673C23.5 3.53654 23.3404 3.9198 23.0566 4.20143L15.239 11.9597C14.766 12.4291 14.5 13.0678 14.5 13.7342V20.0087C14.5 20.4081 14.3408 20.7909 14.0576 21.0724L12.0576 23.0609C11.1114 24.0017 9.5 23.3315 9.5 21.9972V13.7342C9.5 13.0678 9.23399 12.4291 8.76102 11.9597L0.94339 4.20143C0.659609 3.9198 0.5 3.53654 0.5 3.13673V2C0.5 1.17157 1.17157 0.5 2 0.5H22Z", stroke: "black" }, void 0) }), void 0));
};
var BigSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 25" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M22 0.5C22.8284 0.5 23.5 1.17157 23.5 2V3.13673C23.5 3.53654 23.3404 3.9198 23.0566 4.20143L15.239 11.9597C14.766 12.4291 14.5 13.0678 14.5 13.7342V20.0087C14.5 20.4081 14.3408 20.7909 14.0576 21.0724L12.0576 23.0609C11.1114 24.0017 9.5 23.3315 9.5 21.9972V13.7342C9.5 13.0678 9.23399 12.4291 8.76102 11.9597L0.94339 4.20143C0.659609 3.9198 0.5 3.53654 0.5 3.13673V2C0.5 1.17157 1.17157 0.5 2 0.5H22Z", stroke: "black" }, void 0) }), void 0));
};
var FunnelIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.FunnelIcon = FunnelIcon;
//# sourceMappingURL=FunnelIcon.js.map